import { Link } from "react-router-dom";
import { getWhatsAppHref, WHATSAPP_MESSAGES } from "../config/forms.js";
import { SectionMeta } from "../components/SectionMeta.jsx";

const ROLES = ["Creator", "Strategist", "Founder", "Technologist", "Student", "Restless"];

export function FinalCTA() {
  const whatsappHref = getWhatsAppHref(WHATSAPP_MESSAGES.join);

  return (
    <section className="section shell final-cta" id="join">
      <SectionMeta num="§ 07" label="Join the tribe" right="Doors are open" />

      <h2 className="h-display reveal">
        Join the tribe
        <br />
        shaping the <em>future</em>
        <br />
        of work.
      </h2>

      <p className="lead reveal lead-center">
        Whether you&apos;re a creator, a strategist, a founder, a technologist, a
        student — or simply restless about the future — there&apos;s a place for
        you here.
      </p>

      <div className="who-pills reveal">
        {ROLES.map((role) => (
          <span key={role}>{role}</span>
        ))}
      </div>

      <div className="actions reveal cta-actions-spaced">
        {whatsappHref ? (
          <a
            href={whatsappHref}
            className="btn btn-primary"
            target="_blank"
            rel="noopener noreferrer"
          >
            Chat on WhatsApp <span className="arr" aria-hidden="true" />
          </a>
        ) : (
          <Link to="/apply" className="btn btn-primary">
            Become part of Alt Tribe <span className="arr" aria-hidden="true" />
          </Link>
        )}
        <Link to="/apply" className="btn btn-ghost">
          Submit application
        </Link>
        <a
          href={getWhatsAppHref(WHATSAPP_MESSAGES.partner) || "mailto:partners@origamicreative.com"}
          className="btn btn-lime"
          target={getWhatsAppHref(WHATSAPP_MESSAGES.partner) ? "_blank" : undefined}
          rel={getWhatsAppHref(WHATSAPP_MESSAGES.partner) ? "noopener noreferrer" : undefined}
        >
          Partner with us <span className="arr" aria-hidden="true" />
        </a>
      </div>
    </section>
  );
}
